import ApiService from '../../../../../services/ApiService'

export default {
  created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))

    this.institutionRequestedId = JSON.parse(
      localStorage.getItem('institution')
    ).id
    this.getInstitutions()
    this.updateTable()
  },

  data: () => ({
    loading: false,
    institutionLoading: false,
    institution: {},
    visible: false,
    dialog: false,
    userLogged: {},
    expanded: [],
    useRequests: [],
    currentUseRequest: {},
    institutionRequestedId: null,
    institutionRequesterId: null,
    institutions: [],
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    filter: {
      page: 1,
      pageSize: 10,
      institutionRequestedId: null,
      institutionRequesterId: null,
      status: null,
      calibrationPatternName: null,
    },
    statusRequest: 'Aguardando Aprovação',
    statusRequests: ['Aprovado', 'Reprovado', 'Aguardando Aprovação'],
    calibrationPatternName: null,
    headers: [
      {
        text: 'Padrão',
        align: 'center',

        value: 'name',
      },
      {
        text: 'Solicitante',
        align: 'center',

        value: 'requester',
      },
      {
        text: 'Status',
        align: 'center',

        value: 'status',
      },
      {
        text: 'Ações',

        align: 'center',
        value: 'actions',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Solicitante',
        align: 'center',

        value: 'requester',
      },
      {
        text: 'Status',
        align: 'center',

        value: 'status',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
  }),

  computed: {},

  methods: {
    close() {
      this.$emit('close')
    },

    toApprove(request) {
      if (
        this.institution.userType == 2 &&
        this.institutionRequestedId != this.userLogged.institutionId
      ) {
        this.$toast(
          'Você só pode aprovar empréstimos da sua instituição principal!'
        )
        return
      } else {
        this.currentUseRequest = request
        this.currentUseRequest.statusRequest = 0
        this.submit()
      }
    },

    toReprove(request) {
      this.currentUseRequest = request
      this.currentUseRequest.statusRequest = 1
      this.submit()
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.institutionRequesterId = this.institutionRequesterId
      this.filter.status =
        this.statusRequest == null
          ? null
          : this.statusRequests.indexOf(this.statusRequest)
      this.filter.calibrationPatternName = this.calibrationPatternName

      this.updateTable()
    },

    async updateTable() {
      this.loading = true

      this.filter.institutionRequestedId = this.institutionRequestedId
      this.filter.status = this.statusRequests.indexOf(this.statusRequest)
      this.filter.page = this.page

      await this.apiService
        .post('calibrationPattern/listUseRequest', this.filter)
        .then((response) => {
          this.totalPages = response.content.pager.totalPages
          this.useRequests = response.content.requests
          this.loading = false
        })
    },

    async submit() {
      this.dialog = true

      const calibrationPatternUseRequest = {
        Id: this.currentUseRequest.id,
        InstitutionRequesterId: this.currentUseRequest.institutionRequesterId,
        InstitutionRequestedId: this.currentUseRequest.institutionRequestedId,
        CalibrationPatternRequesterId:
          this.currentUseRequest.calibrationPatternId,
        UseRequestObservation: this.currentUseRequest.requestObservation,
        StatusRequest: this.currentUseRequest.statusRequest,
      }

      await this.apiService
        .post('calibrationPattern/useResponse', calibrationPatternUseRequest)
        .then(() => {
          setTimeout(() => {
            this.dialog = false
          }, 4000)
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content.filter(
          (x) => x.id != this.institutionRequestedId
        )
        this.institutionLoading = false
      })
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 10,
        institutionRequestedId: null,
        institutionRequesterId: null,
        status: null,
        calibrationPatternName: null,
      }
      this.institutionRequestedId = this.institutionRequestedId
      this.institutionRequesterId = null
      this.statusRequest = 'Aguardando Aprovação'
      this.calibrationPatternName = null

      this.updateTable()
    },
  },

  watch: {
    page() {
      this.updateTable()
    },
  },
}
